import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Backdrop,
  CircularProgress,
  Typography,
} from "@material-ui/core";
import * as React from "react";
import Box from "@material-ui/core/Box";
import { convertToBoolean } from "../constants/constants";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      padding: 3,
    },
    button: {
      margin: theme.spacing(1),
      width: "20%",
      height: 48,
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: "#fff",
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary,
    },
    control: {
      padding: theme.spacing(1) * 2,
    },
  });
interface Props extends WithStyles<typeof styles> {
  isLoading: Boolean;
  progress?: any;
}
class LoadingComponents extends React.Component<Props> {
  render() {
    const { classes, isLoading, progress } = this.props;
    return (
      <React.Fragment>
        <Backdrop
          className={classes.backdrop}
          open={convertToBoolean(isLoading)}
          onClick={() => {}}
        >
          {!progress ? (
            <CircularProgress style={{ color: "orange" }} color="inherit" />
          ) : (
            <Box position="relative" display="inline-flex">
              <CircularProgress
                variant="determinate"
                style={{ color: "orange" }}
                value={progress}
              />
              {progress > 0 && (
                <Box
                  top={0}
                  left={0}
                  bottom={0}
                  right={0}
                  position="absolute"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Typography
                    variant="h6"
                    component="div"
                    style={{ color: "white", fontSize: 14 }}
                  >{`${Math.round(progress)}%`}</Typography>
                </Box>
              )}
            </Box>
          )}
        </Backdrop>
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(LoadingComponents);
